import { render, staticRenderFns } from "./ZoneServiceVersion.vue?vue&type=template&id=e63ec2c0&"
import script from "./ZoneServiceVersion.vue?vue&type=script&lang=js&"
export * from "./ZoneServiceVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports